import { BookOpen, FileSearch, FileText, Inbox, ListTodo } from 'lucide-react'
import { getAgentCategoryMeta } from './agentCategories'

/** @type {Record<string, { icon: typeof FileSearch; accent: string }>} */
export const AGENT_CARD_META = {
  basecamp_data_analyzer: { icon: FileSearch, accent: 'blue' },
  basecamp_task_creator: { icon: ListTodo, accent: 'indigo' },
  outlook_folder_map: { icon: Inbox, accent: 'sky' },
  outlook_folder_reduce: { icon: FileText, accent: 'violet' },
  knowledge_assistant: { icon: BookOpen, accent: 'emerald' },
}

/**
 * @param {string} agentKey
 * @param {string} [categoryKey]
 */
export function getAgentCardMeta(agentKey, categoryKey) {
  const key = String(agentKey || '').trim()
  const known = AGENT_CARD_META[key]
  if (known) return known

  const category = getAgentCategoryMeta(categoryKey || 'basecamp')
  return { icon: category.icon, accent: 'blue' }
}
